const locale = {
    placeholder: 'Sélectionner l\'heure',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/fr_FR.tsx